import { format, isAfter, isEqual, isValid, subYears } from 'date-fns'
import { Prescription } from '../../types'

export const isPrescriptionRenewableByAge = (createdDate: Date | string): boolean => {
  const created = new Date(createdDate)
  if (!isValid(created)) return false
  const cutoff = subYears(new Date(), 1)
  return isAfter(created, cutoff) || isEqual(created, cutoff)
}

export const transformPrescriptions = (prescription: Prescription) => {
  const {
    id,
    scid,
    createdDate,
    prescribedItems,
    isPaperPrescription,
    issueSnapshot: { patient, prescriber, location },
  } = prescription

  return {
    id,
    patientName: `${patient?.givenNames ?? ''} ${patient?.familyName ?? ''}`,
    prescriberName: `${prescriber?.givenNames ?? ''} ${prescriber?.familyName ?? ''}`,
    locationName: location?.name ?? '',
    scid,
    createdDate: format(new Date(createdDate), 'yyyy-MM-dd'),
    prescribedItems: prescribedItems.map(
      ({ genericName, quantity, state, patientInstructions, numberOfRepeatsAuthorised }) => ({
        displayName: `${genericName} | Qty: ${quantity}`,
        state,
        patientInstructions,
        numberOfRepeatsAuthorised,
      })
    ),
    isPaperPrescription,
    isEmergencySupply: prescribedItems.some((drug) => drug.emergencySupply),
    isSendToPharmacy: prescribedItems.some(
      (drug) => drug.sendToPharmacy && drug.sendToPharmacy !== ''
    ),
  }
}
